import { CalendarRange } from 'lucide-react'
import { RequirePermission } from '@/features/auth/guards'
import { CourseCalendarPage } from '@/pages/courses/CourseCalendarPage'
import { CourseEditPage } from '@/pages/courses/CourseEditPage'
import { CourseRunPage } from '@/pages/courses/CourseRunPage'
import { CourseRunsPage } from '@/pages/courses/CourseRunsPage'
import { CoursesPage } from '@/pages/courses/CoursesPage'
import { FamilyCoursesPage, MyCoursesPage } from '@/pages/courses/MyCoursesPage'
import type { AppModule } from '../moduleRegistry'

const keywords = 'courses catalogue programme cohort schedule sessions runs calendar'

export const module: AppModule = {
  id: 'courses',
  schoolModule: 'courses',
  routes: {
    admin: [
      {
        path: 'courses',
        element: <RequirePermission permission="courses.manage" />,
        children: [
          { index: true, element: <CoursesPage /> },
          { path: 'new', element: <CourseEditPage /> },
          { path: ':id', element: <CourseEditPage /> },
          { path: 'runs', element: <CourseRunsPage /> },
          { path: 'runs/:id', element: <CourseRunPage /> },
          { path: 'calendar', element: <CourseCalendarPage /> },
        ],
      },
    ],
    staff: [{ path: 'my-courses', element: <MyCoursesPage /> }],
    family: [{ path: 'courses', element: <FamilyCoursesPage /> }],
  },
  nav: {
    admin: [
      {
        group: 'Academics',
        order: 45,
        item: {
          label: 'Courses',
          to: '/admin/courses',
          icon: CalendarRange,
          permission: 'courses.manage',
          keywords,
          children: [
            { label: 'Catalogue', to: '/admin/courses', permission: 'courses.manage', end: true },
            { label: 'Scheduled courses', to: '/admin/courses/runs', permission: 'courses.manage' },
            { label: 'Course calendar', to: '/admin/courses/calendar', permission: 'courses.manage' },
          ],
        },
      },
    ],
    staff: [
      { order: 13, item: { label: 'My courses', to: '/staff/my-courses', icon: CalendarRange, keywords } },
    ],
    family: [
      { order: 17, item: { label: 'My courses', to: '/portal/courses', icon: CalendarRange, keywords } },
    ],
  },
}
